var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import * as R from 'ramda';
import { ElementDefType } from '../../models/def.types';
//
export var isNotNil = R.complement(R.isNil);
//
export var isElementBlock = function (it) { return it.$type === ElementDefType.BLOCK; };
export var isElementField = function (it) { return it.$type === ElementDefType.FIELD; };
export var isMobile = function () {
    try {
        return !document;
    }
    catch (_a) {
        return true;
    }
};
export var mapIndexed = function (map) { return function (items) { return items.map(map); }; };
export var mapStringPath = function (path) {
    return !path ? '' : path.map(function (p, i) { return (typeof p === 'number' ? "[" + p + "]" : "" + (!i ? '' : '/') + p); }).join('');
};
// convert to json
export var str2Json = R.when(R.is(String), function (str) {
    try {
        return JSON.parse(str);
    }
    catch (e) {
        return {};
    }
});
// map tree
export var mapElementTreeAsImmutable = function (map) {
    var mapTree = R.pipe(function (it, parent, path) { return [map(it, parent, path), path]; }, function (_a) {
        var parent = _a[0], path = _a[1];
        return R.evolve({
            elements: mapIndexed(function (el, i) { return mapTree(el, parent, __spreadArrays(path, [i, el.code])); }),
        })(parent);
    });
    return function (it, parent) { return it && mapTree(it, parent, [it.code]); };
};
// map tree mutable
export var mapElementTreeAsMutable = function (map) {
    var mapTree = R.pipe(map, function (element) {
        if (isElementBlock(element)) {
            // calc elements
            element.elements.forEach(mapTree);
        }
        return element;
    });
    return function (it) { return it && mapTree(it); };
};
// foreach element tree
export var forEachElementTree = function (fn, it) {
    mapElementTreeAsImmutable(R.tap(fn))(it);
};
// map flatten
var mergeAllValues = function (items) { return (items ? R.mergeAll(items.filter(R.complement(R.isNil))) : {}); };
export var mapFormDefFlatten = function (map) { return function (it) {
    var _a;
    if (!it) {
        return null;
    }
    var elements = (it.$type === ElementDefType.BLOCK ? it : {}).elements;
    var value = map(it);
    return __assign(__assign({}, (value !== undefined ? (_a = {}, _a[it.id] = value, _a) : {})), (!elements ? {} : mergeAllValues(elements.map(mapFormDefFlatten(map)))));
}; };
// mock formula element
var elementMock = {
    block: null,
    parent: null,
    blocks: function (code) {
        return code ? this : [this];
    },
    fields: function (code) {
        return code ? this : [this];
    },
    value: null,
    isBlock: function () {
        return true;
    },
    isField: function () {
        return true;
    },
    isValid: function () {
        return true;
    },
    isValueChanged: function () {
        return false;
    },
    isValueFetching: function () {
        return false;
    },
};
export var FORMULA_ELEMENT_MOCK = R.reduce(function (acc, el) { return (!acc ? el : R.pipe(R.assoc('block', acc), R.assoc('parent', acc))(el)); }, null, R.repeat(elementMock, 10));
// ramda utils
export var asyncTap = function (fn, ms) {
    if (ms === void 0) { ms = 0; }
    return R.tap(function (x) { return setTimeout(function () { return fn(x); }, ms); });
};
//# sourceMappingURL=_.utils.js.map